import { TcoCalculationItem } from "../../../../../models/calculation/tcoCalculationItem"
import React from "react"
import ReactECharts from "echarts-for-react"
import { useCapexEchartsOption } from "../hooks/useCapexEchartsOption"
import { ManualPricesSystems } from "../../SelectSystem/hooks/useManualPrices"

type CapexGraphProps = {
  chosenSystemOne: TcoCalculationItem
  chosenSystemTwo: TcoCalculationItem
  manualPrices?: ManualPricesSystems | null
}
export const CapexGraph: React.FC<CapexGraphProps> = ({
  chosenSystemOne,
  chosenSystemTwo,
  manualPrices = null,
}) => {
  const capexOption = useCapexEchartsOption(
    chosenSystemOne,
    chosenSystemTwo,
    manualPrices
  )

  return (
    <>
      {capexOption && (
        <ReactECharts
          option={capexOption}
          style={{ height: "100%", width: "100%" }}
          opts={{ renderer: "svg" }}
        />
      )}
    </>
  )
}
